export function Suggestions() {
  return <div>Suggestions</div>;
}
